import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Select from "react-select";

const StyledSelect = styled(Select)`
  margin: 0;

  ${({ theme, size }) =>
    theme &&
    css`
      font-size: 14px;
      font-weight: 400;
      /* small = 6rem, large= 9rem, default size 7rem */
      width: ${size ? size : "7"}rem;

      /* Main Outer Container */
      .gfx-pill-dropdown {
        border: none;
        margin-right: 0;
      }

      .gfx-pill-dropdown__value-container {
        height: 32px;
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
        padding: 0rem 0.7rem;
      }

      .gfx-pill-dropdown__control {
        background-color: transparent;
        border-color: ${theme.themeColors.secondary};
        border-radius: 21px;
        min-height: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;

        /* Input active / focus styles */

        &.gfx-pill-dropdown__control--menu-is-open {
          .gfx-pill-dropdown__indicator {
            svg {
              transform: rotate(180deg);
            }
          }
        }

        &.gfx-pill-dropdown__control--is-focused {
          border-color: ${theme.themeColors.primary};
          box-shadow: none;
        }

        .gfx-pill-dropdown__indicators {
          height: 30px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .gfx-pill-dropdown__indicator {
          padding: 0 0.8rem;
        }

        .gfx-pill-dropdown__indicator-separator {
          display: none;
        }
      }
      /* Dropdown wrapper class */
      .gfx-pill-dropdown__menu {
        z-index: 2;

        /* Dropdown Select Options */
        .gfx-pill-dropdown__option {
          color: ${theme.themeColorShades.dark800};
        }
      }
      /* Focused Select Option */
      .gfx-pill-dropdown__option--is-focused {
        background-color: ${theme.themeColors.lightGreen4};
      }

      .gfx-pill-dropdown__option--is-selected {
        background-color: ${theme.themeColors.primary};
        color: ${theme.themeColors.white} !important;
      }
    `};
`;

function PillDropdown({ defaultValue, options, onChange, value, size }) {
  return (
    <StyledSelect
      className="gfx-pill-dropdown"
      classNamePrefix="gfx-pill-dropdown"
      defaultValue={defaultValue}
      isSearchable={false}
      options={options}
      menuPlacement="auto"
      onChange={onChange}
      value={value}
      size={size}
    />
  );
}

export default PillDropdown;
